import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root',
})
export class UploadFilesService {
  remoteApiUrl: string;
  imageUrl: string;
  filePreview = false;
  public tenantId = 1;
  constructor(
    private _httpClient: HttpClient, 
     //private _envoirnment: EnvironmentService, 
     //private _filesBoxService: FilesBoxService,
     //private config: ConfigStateService
  ) {

    // this._envoirnment.getApiUrl$('default').subscribe(res => {
    //   //this.remoteApiUrl = res + '/api/app/filesbox';
    // })
    
    this.remoteApiUrl = environment.apiBaseUrl+environment.urls.upload_General_Single_File_Async;

    // var user = config.getOne("currentUser");
    // this.tenantId = user.tenantId;
  }

  
  // uploadVendorFile(model:any,formData: FormData): Observable<any> {
  //   return this._httpClient.post(`${environment.apiBaseUrl+environment.urls.FilesBox_UploadFiles}?fileName=${model.fileName}&documentType=${model.documentType}&documentTypeId=${model.documentTypeId}&tenantId=1&multipleFiles=true`, formData);
  // }

  uploadFile(
    file: any,
    documentType: string,
    documentTypeId: string,
    multipleFiles: boolean = false,
    displayName?: any ,
  ) {
    
    if (file) {
      const formData: FormData = new FormData();
      
      if (Array.isArray(file)) {
        file.forEach((f) => formData.append('files', f));
      }
      else {
        formData.append('files', file);
      }

      if(Array.isArray(displayName)){
        displayName.forEach((n) => formData.append('displayName', n));
      }
      else{
        formData.append('displayName', displayName);
      }

      //formData.append('files', file);
      formData.append('documentType', documentType);
      formData.append('documentTypeId', documentTypeId);
      formData.append('multipleFiles', multipleFiles as any as string);
      
      // formData.append('currentTenantId', this._currentUserSpecification.currentTenantId);

      return this._httpClient.post<any>(this.remoteApiUrl, formData);
    }
  }

  uploadFileByMultipleDocumentTypeId(
    file: any,
    documentType: string,
    documentTypeId: number[],
    multipleFiles: boolean = false,
    displayName?: any ,
  ) {

    
    if (file) {
      const formData: FormData = new FormData();

      //file.forEach((f) => formData.append('files', f));

      formData.append('files', file);
      formData.append('documentType', documentType);
      formData.append('documentTypeId', documentTypeId.toString());
      formData.append('multipleFiles', multipleFiles as any as string);
      formData.append('displayName', displayName);
      // formData.append('currentTenantId', this._currentUserSpecification.currentTenantId);

      return this._httpClient.post<any>(this.remoteApiUrl + "/Upload-File-By-Multiple-Document-Type-Id", formData);
    }
  }

  deleteFile(documentId: number) {
    
    //const apiUrl = environment.apiBaseUrl + "/Upload/UploadFile/DeleteFile";
    //const url = apiUrl + '/' + documentId;
    const url = `${environment.apiBaseUrl}/Upload/DeleteFile?id=${documentId}`;

    return this._httpClient.delete<any>(url);
  }

  getUploadedFile(documentId: number, documentType: string) {

    // const url = this.remoteApiUrl + '/download-file-ByDocumentId' + '?documentId=' + documentId + '&tenantId=' + this.tenantId;
    // location.href = url;

    const url = `${environment.apiBaseUrl}/Upload/DownloadFileByDocumentTypeId?documentId=${documentId}`;
    location.href = url;

  }

  getTempFile(fileName: string, fileToken: string, contentType: string) {
    
    const apiBaseUrl = environment.apiBaseUrl; // Ensure `environment` is properly imported    
    const fullUrl = `${apiBaseUrl}/Upload/DownloadTempFile?fileName=${fileName}&fileToken=${fileToken}&contentType=${contentType}`;
    
    location.href = fullUrl;
  }

  downloadExportToExcelFile(fileName: string, fileToken: string, contentType: string) {
    const url = this.remoteApiUrl + '/download-file' + '?fileName=' + fileName + '&fileToken=' + fileToken + '&contentType=' + contentType;
    location.href = url;
  }


  getSampleFile(fileName: string) {
    const url = this.remoteApiUrl + '/sample-file' + '?fileName=' + fileName;
    location.href = url;
  }

  public urlImport = "";
  uploadTempFile(file: File): Observable<any> {
    if (file) {



      const formData: FormData = new FormData();
      if (Array.isArray(file)) {
        file.forEach((f) => formData.append('files', f));
      }
      else {
        formData.append('files', file);
      }

      this.urlImport = environment.apiBaseUrl + '/CustomImportExport/UploadTempFile';
      // this.urlImport = environment.baseUrl + 'api/app/importexport';
      // var urlImport = this._envoirnment.getApiUrl() + '/api/app/importexport';

      // this._envoirnment.getApiUrl$('default').subscribe(res => {
      // })
;
      return this._httpClient.post<any>(this.urlImport, formData);
    }
  }

}
